import { Plus } from 'lucide-react'
import './node-add-popup.css'

type NodeAddPopupProps = {
	position: { x: number; y: number }
	onAdd: () => void
	onClose: () => void
}

export function NodeAddPopup({ position, onAdd }: NodeAddPopupProps) {
	return (
		<div
			className="node-add-popup"
			style={{
				left: position.x,
				top: position.y - 40,
			}}
		>
			<button
				onClick={(e) => {
					e.stopPropagation()
					onAdd()
				}}
				onContextMenu={(e) => e.preventDefault()}
				className="canvas-popup-button"
				data-variant="add"
				title="Add node"
			>
				<Plus size={18} className="canvas-popup-button-icon" />
			</button>
		</div>
	)
}
